module.exports = __webpack_public_path__ + "img/vox.55a731a3.jpg";